/* COMMONS */
import productDetailsModal from '../../common/modal/modal';

/* COMMONS - VUEX */
import modalStore from '../../common/modal/modal.vuex';

/* MODULES */
import CD03cardProduct from '../../modules/CD03-card-product/CD03-card-product';
import chn01Channels from '../../modules/CHN01-channels/CHN01-channels';
import set01Settlement from '../../modules/SET01-settlement/SET01-settlement.js';
import sld02Slider from '../../modules/SLD02-slider/SLD02-slider';

import Vue from 'vue';
import {store, base} from './basicLayout';

document.body.addEventListener('jsLoaded', function () {
	store.registerModule('productDetailsStore', modalStore);

	(() => new Vue({
		el: '#vue-app',
		components: {
			/* COMMONS */
			'modal': productDetailsModal,

			/* MODULES */
			'cd03-card-product': CD03cardProduct,
			'chn01-channels': chn01Channels,
			'set01-settlement': set01Settlement,
			'sld02-slider': sld02Slider
		},
		extends: base
	}))();

});



// WEBPACK FOOTER //
// ../source/build-entry/layouts/lelo.js